import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const UserCheckService = {
    isUserActive: (body) => {
        return axios.post(`${baseUrl}/get-user-web`, body)
    }
}

export default UserCheckService